export default __webpack_public_path__ + "static/gw2-box-0bf17ea5c37c0c2ebed0f5c3559b9e67.png";